export const FreeGames = [
  {
    id: 202401012,
    brand: "playcutegames",
    title: "American Doll Halloween Night",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/american-doll-halloween-night/250x142.png",
    iframe: "https://games.cutedressup.net/american-doll-halloween-night/",
    Walkthrough: "https://www.youtube.com/embed/iHNnTNcR6wA",
    dis:" Step into a world where your beloved American Girl dolls transform into the ultimate Halloween icons. Get ready to experience the thrill and magic of Halloween in a whole new dimension with American Doll Halloween Night. This dress-up game offers an extensive selection of festive outfits, accessories, and hairstyles, allowing you to create the spookiest, most stylish looks for your dolls.",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Peppa Pig's Halloween Party",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/peppa-pigs-halloween-party/250x142.png",
    iframe: "https://games.cutedressup.net/peppa-pigs-halloween-party/",
    Walkthrough: "https://www.youtube.com/embed/WX9e1yLEpgk",
    dis:"Welcome to Peppa Pig’s Halloween Party, an exciting dress-up game where Peppa, Daddy Pig, and Mummy Pig are getting ready for a fun-filled Halloween party! In this playful game, you get to be the stylist for the entire family, helping them choose the perfect Halloween costumes to stand out at the spookiest event of the year.",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Roblox Halloween Costume Party",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/roblox-halloween-costume-party/250x142.png",
    iframe: "https://games.cutedressup.net/roblox-halloween-costume-party/",
    Walkthrough: "https://www.youtube.com/embed/DcXvkNvuQnk",
    dis:"Roblox Halloween Costume Party is the ultimate dress-up experience that brings out your creativity! Dive into a world of Roblox-inspired costumes and accessories, where you can create your spookiest, funniest, or most imaginative Halloween looks. Mix and match a variety of outfits to make sure you stand out at the party. Whether you're going for scary, cute, or quirky, the possibilities are endless! Compete with friends in costume contests, show off your unique style, and immerse yourself in the festive Halloween spirit. Get ready for fun-filled fashion in this exciting holiday-themed game!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Nightmare Couple Halloween Party",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/nightmare-couple-halloween-party/250x142.png",
    iframe: "https://games.cutedressup.net/nightmare-couple-halloween-party/",
    Walkthrough: "https://www.youtube.com/embed/",
    dis:"Nightmare Couple Halloween Party is a spooky and stylish dress-up game where you can help the ultimate nightmare couple prepare for their eerie Halloween bash. Select from a variety of creepy costumes, haunting accessories, and makeup styles to give the couple their perfect spine-chilling look. Unleash your creativity and fashion sense to make this Halloween party an unforgettable one for the nightmare couple!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "My Pet Care Salon",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-pet-care-salon/250x142.png",
    iframe: "https://games.cutedressup.net/my-pet-care-salon/",
    Walkthrough: "https://www.youtube.com/embed/_VMf_DKgfJw",
    dis:"My Pet Care Salon invites you to run your very own pet spa! Groom, pamper, and style a variety of adorable pets with fun, interactive activities. From bath time and nail trimming to trendy haircuts and accessory styling, provide the best care for your furry clients. Manage your salon, meet different pets, and earn rewards as you create a welcoming environment for pets and their owners. Transform your pet care dreams into reality and become the ultimate pet stylist!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Celebrity Aesthetic Challenge",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-aesthetic-challenge/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-aesthetic-challenge/",
    Walkthrough: "https://www.youtube.com/embed/Nsi2lAXAKDY",
    dis:"Celebrity Aesthetic Challenge lets you explore a range of unique celebrity-inspired styles! Compete in fun fashion challenges as you mix and match outfits, accessories, and hairstyles to recreate iconic looks. From E-girl and Soft-girl vibes to edgy streetwear and glam red carpet ensembles, showcase your creativity and win the ultimate fashion battle. Can you rise to the challenge and become the trendsetting fashion icon? Let the style showdown begin!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Ellie And Friends Art Hoe Aesthetic",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ellie-and-friends-art-hoe-aesthetic/250x142.png",
    iframe: "https://games.cutedressup.net/ellie-and-friends-art-hoe-aesthetic/",
    Walkthrough: "https://www.youtube.com/embed/LPXMCq2iwAg",
    dis:"Ellie And Friends Art Hoe Aesthetic is all about exploring creativity through unique fashion and art! Dress them up in colorful outfits, mix and match funky accessories, and dive into the world of artistic expression. From painting and drawing to choosing the perfect look, this game lets you celebrate individuality and artistic flair with Ellie and her friends. Get ready to unleash your inner artist!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Glam And Glossy Summer Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/glam-and-glossy-summer-look/250x142.png",
    iframe: "https://games.cutedressup.net/glam-and-glossy-summer-look/",
    Walkthrough: "https://www.youtube.com/embed/lOhcTxMCn68",
    dis:"Glam And Glossy Summer Look is your go-to game for creating stunning summer styles! Dive into a wardrobe filled with trendy outfits, shimmering accessories, and sun-kissed makeup. Mix and match to craft the perfect glossy summer look, whether it’s for a beach day, a pool party, or a chic city outing. Show off your fashion sense and shine bright all summer long!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "American Doll In Princess Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/american-doll-in-princess-style/250x142.png",
    iframe: "https://games.cutedressup.net/american-doll-in-princess-style/",
    Walkthrough: "https://www.youtube.com/embed/zIEzcNSn4ZM",
    dis:"Embark on a royal journey with “American Doll in Princess Style”! Dress up your beloved American Doll in enchanting princess outfits, complete with sparkling tiaras, elegant gowns, and magical accessories. Create a fairy tale look that will make your doll shine at any royal event. Let your creativity soar as you explore various styles, from classic princess attire to modern regal trends. Perfect for anyone who loves fashion, fantasy, and fun!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Secret Agents Mission to Save Earth",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/secret-agents-mission-to-save-earth/250x142.png",
    iframe: "https://games.cutedressup.net/secret-agents-mission-to-save-earth/",
    Walkthrough: "https://www.youtube.com/embed/FIYRQOu95Hc",
    dis:"“Secret Agents Mission to Save Earth” is an action-packed adventure game where players take on the role of elite secret agents tasked with protecting the planet. Navigate through intense missions, solve challenging puzzles, and battle formidable foes to thwart a global threat. Utilize high-tech gadgets, stealth tactics, and your wits to uncover conspiracies and save Earth from imminent danger. Embark on this thrilling journey and prove you have what it takes to be a top secret agent!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Count And Tracing Number Games",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/count-and-tracing-number-games/250x142.png",
    iframe: "https://games.cutedressup.net/count-and-tracing-number-games/",
    Walkthrough: "https://www.youtube.com/embed/BkOP4GwUSSo",
    dis:"“Count and Tracing Number Games” offers an interactive way for kids to learn numbers. This game combines fun and education, helping children to trace numbers, count objects, and recognize numerals. With vibrant graphics and engaging gameplay, kids can practice their math skills while enjoying a playful environment. Perfect for early learners, it fosters number recognition, fine motor skills, and counting abilities.",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Celebrity E-Girl vs Soft-Girl",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-e-girl-vs-soft-girl/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-e-girl-vs-soft-girl/",
    Walkthrough: "https://www.youtube.com/embed/MnKGsT6LlHw",
    dis:"Choose your style path in Celebrity E-Girl vs Soft-Girl! Explore the contrasting worlds of edgy E-Girl fashion and soft, pastel-inspired Soft-Girl trends. Mix and match outfits, and accessories to express your unique fashion statement. Compete in fashion challenges, socialize with friends, and become a trendsetter in this dynamic virtual fashion showdown!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Baby Zara Outdoor Cleaning",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/baby-zara-outdoor-cleaning/230x131.png",
    iframe: "https://games.cutedressup.net/baby-zara-outdoor-cleaning/",
    Walkthrough: "https://www.youtube.com/embed/7OX5qj1wgec",
    dis:"Join Baby Zara in her Outdoor Cleaning adventure! Help her tidy up the backyard, pick up trash, and plant flowers. With your assistance, the garden will look fresh and beautiful. Enjoy a fun and educational experience as you teach Baby Zara the importance of keeping the environment clean and green.",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Celebrity Coachella Vibe Outfits",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-coachella-vibe-outfits/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-coachella-vibe-outfits/",
    Walkthrough: "https://www.youtube.com/embed/cPUe0eZeaSE",
    dis:"Celebrity Coachella Vibe Outfits lets you dress up your favorite celebrities in trendy festival outfits. Explore a wide range of boho-chic styles, from flowy dresses to edgy accessories. Create stunning looks perfect for the Coachella vibe and make your celebs stand out at the festival. Get ready to unleash your inner fashionista! Enjoy playing these new cute games for girls. Have a great time with our cute games. If you are looking for the best makeup games, then look no further. Cutedressup.com has a cute collection of games for makeup.",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Baby Zara Home Cleaning",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/baby-zara-home-cleaning/230x131.png",
    iframe: "https://games.cutedressup.net/baby-zara-home-cleaning/",
    Walkthrough: "https://www.youtube.com/embed/Snhv7g8P478",

    dis:"Welcome to Baby Zara Home Cleaning. Join Baby Zara in her Home Cleaning adventure! Help Zara tidy up her home by organizing toys, sweeping floors, and wiping windows. This fun and interactive game teaches kids the importance of cleanliness while keeping them entertained. Get ready for a sparkling clean home with Baby Zara!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Besties Reunion Party",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/besties-reunion-party/230x131.png",
    iframe: "https://games.cutedressup.net/besties-reunion-party/",
    Walkthrough: "https://www.youtube.com/embed/",
    dis:"Besties Reunion Party – Join the ultimate Besties Reunion Party! Plan an unforgettable celebration with your closest friends, filled with laughter, memories, and stylish outfits. Choose the perfect attire, decorate the venue, and capture every special moment. Whether it’s a night out or a cozy get-together, this party is all about friendship and fun. Reunite with your besties and make this event a night to remember with fabulous fashion and unique party ideas!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Lovie Chic’s Insta Glam Squad",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lovie-chics-insta-glam-squad/250x142.png",
    iframe: "https://games.cutedressup.net/lovie-chics-insta-glam-squad/",
    Walkthrough: "https://www.youtube.com/embed/r3uDcghe8bQ",
    dis:"Step into the world of glamour with Lovie Chic’s Insta Glam Squad! Join the squad and explore the latest trends in fashion, makeup, and styling. From chic streetwear to red carpet looks, unleash your inner fashionista and create stunning Insta-worthy outfits. With endless options for customization and photo shoots, become the ultimate style influencer and take the fashion world by storm with your Insta Glam Squad!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Celebrity Last Fling Before The Ring",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-last-fling-before-the-ring/230x131.png",
    iframe: "https://games.cutedressup.net/celebrity-last-fling-before-the-ring/",
    Walkthrough: "https://www.youtube.com/embed/YXvdhpOqVfI",
    dis:"Get ready to celebrate the bride-to-be’s last hurrah with Celebrity Last Fling Before The Ring! Join the ultimate bachelorette bash filled with glitz, glam, and unforgettable moments. From chic outfits to fun games, make memories to last a lifetime before the big day arrives. Let the party begin!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Lovie Chic’s Glamorous Prom Party",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lovie-chics-glamorous-prom-party/230x131.png",
    iframe: "https://games.cutedressup.net/lovie-chics-glamorous-prom-party/",
    Walkthrough: "https://www.youtube.com/embed/9QVo6j0Z-Bo",
    dis:"Step into the spotlight with Lovie Chic’s Glamorous Prom Party! Explore a dazzling array of dresses, accessories, and hairstyles to create your perfect prom look. From elegant ball gowns to chic cocktail dresses, we have everything you need to shine on your special night. Get ready to dance the night away in style and make memories that will last a lifetime!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Fashion Intern A Journey into Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/fashion-intern-a-journey-into-style/230x131.png",
    iframe: "https://games.cutedressup.net/fashion-intern-a-journey-into-style/",
    Walkthrough: "https://www.youtube.com/embed/ZNVi9uqACg8",
    dis:"Embark on a transformative journey into the world of style with Fashion Intern! From learning the ropes to curating chic ensembles, immerse yourself in the fast-paced, glamorous world of fashion. With each task, hone your skills and unlock new opportunities to shine. Are you ready to make your mark in the industry? Join Fashion Intern and let your style journey begin!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "BFF’s Hot Summer Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-hot-summer-style/230x131.png",
    iframe: "https://games.cutedressup.net/bffs-hot-summer-style/",
    Walkthrough: "https://www.youtube.com/embed/bMP66CtLGcg",
    dis:"Get ready to sizzle in the sun with BFF’s Hot Summer Style! Dive into a world of vibrant colors, breezy fabrics, and trendy silhouettes, curated to keep you cool and stylish all season long. From chic sundresses to playful rompers, our collection offers endless options to slay your summer look. Whether you’re lounging by the pool or hitting the beach, make a splash with BFF’s Hot Summer Style!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Lovie Chic’s Holographic Trends",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lovie-chics-holographic-trends/230x131.png",
    iframe: "https://games.cutedressup.net/lovie-chics-holographic-trends/",
    Walkthrough: "https://www.youtube.com/embed/FElz01x8W3A",
    dis:"Step into the future of fashion with Lovie Chic’s Holographic Trends! Embrace the mesmerizing allure of holographic fabrics and accessories, where every outfit radiates a futuristic glow. From shimmering dresses to iridescent accessories, our collection offers a dazzling array of options to elevate your style game. Stand out from the crowd and make a bold fashion statement with Lovie Chic’s Holographic Trends!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Celebrity Casual Trendy Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-casual-trendy-look/230x131.png",
    iframe: "https://games.cutedressup.net/celebrity-casual-trendy-look/",
    Walkthrough: "https://www.youtube.com/embed/WipPwffGnpw",
    dis:"Explore the world of casual chic with our “Celebrity Casual Trendy Look” collection! Discover effortless yet stylish outfits curated for a relaxed yet fashionable vibe. Embrace the latest trends, mix and match pieces, and elevate your everyday style with ease. Whether you’re running errands or grabbing coffee with friends, rock your look like a celebrity!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "From Nerd To School Popular",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/from-nerd-to-school-popular/230x131.png",
    iframe: "https://games.cutedressup.net/from-nerd-to-school-popular/",
    Walkthrough: "https://www.youtube.com/embed/-wk5sCz9vRc",
    dis:"Embark on a transformation journey “From Nerd To School Popular”! Help our protagonist navigate high school life, overcome challenges, and discover their true potential. With your guidance, they’ll undergo a stylish makeover, gain confidence, and rise to the top of the social ladder. Experience the ultimate high school makeover story and watch as our hero transforms from a shy outsider to a beloved school icon!",
  },
  { 
    id: 202401012,
    brand: "playcutegames",
    title: "BFF Easter Photobooth Party",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bff-easter-photobooth-party/230x131.png",
    iframe: "https://games.cutedressup.net/bff-easter-photobooth-party/",
    Walkthrough: "https://www.youtube.com/embed/SPLZdUVIGQI",
    dis:"Step into the whimsical world of the “BFF Easter Photobooth Party” and celebrate the joyous holiday with your best friends! Join in on the festive fun as you dress up in vibrant Easter-themed outfits, pose for adorable photos in the photobooth, and create lasting memories together. With colorful props, festive decorations, and endless laughter, this is the perfect way to capture the spirit of Easter and enjoy a delightful day with your BFFs.",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Lovie Chick’s Preppy Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lovie-chicks-preppy-look/230x131.png",
    iframe: "https://games.cutedressup.net/lovie-chicks-preppy-look/",
    Walkthrough: "https://www.youtube.com/embed/i9Z8eO93HlQ",
    dis:"Explore the enchanting fusion of nostalgia and celebrity flair with Lovie Chick’s Preppy Look’. Dive into a whimsical realm where childhood memories inspire vibrant, playful fashion choices. Discover quirky outfits and accessories that blend retro charm with modern celebrity style. Embrace your inner child and express yourself in a fun, creative way!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Celebrity Kidcore Aesthetic",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-kidcore-aesthetic/230x131.png",
    iframe: "https://games.cutedressup.net/celebrity-kidcore-aesthetic/",
    Walkthrough: "https://www.youtube.com/embed/riL8mMHsoc0",
    dis:"Explore the enchanting fusion of nostalgia and celebrity flair with ‘Celebrity Kidcore Aesthetic’. Dive into a whimsical realm where childhood memories inspire vibrant, playful fashion choices. Discover quirky outfits and accessories that blend retro charm with modern celebrity style. Embrace your inner child and express yourself in a fun, creative way! ",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Lovie Chics Spring Break Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lovie-chics-spring-break-fashion/230x131.png",
    iframe: "https://games.cutedressup.net/lovie-chics-spring-break-fashion/",
    Walkthrough: "https://www.youtube.com/embed/T1YYciNmyu0",
    dis:"Lovie Chics Spring Break Fashion” is your ultimate destination for chic and trendy outfits perfect for the spring break season! Explore our curated collection of vibrant dresses, stylish swimwear, and must-have accessories designed to elevate your style and make a statement wherever you go. Whether you’re hitting the beach, lounging by the pool, or exploring new destinations, we have everything you need to look and feel fabulous all spring break long. Embrace the sunny vibes and shop our collection now",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Mr Hacker: The Museum Hunt",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/mr-hacker-the-museum-hunt/250x142.png",
    iframe: "https://games.cutedressup.net/bestgamespot/mr-hacker-the-museum-hunt/",
    Walkthrough: "https://www.youtube.com/embed/xhIu5t0EaZo",
    dis:"Join the thrilling heist in ‘Mr Hacker: The Museum Hunt.’ As a hired hacker, your mission is to crack 150 vaults in a high-stakes museum break-in. Unleash your skills, avoid security, and uncover precious diamonds. Are you up for the challenge? Play now and immerse yourself in the world of cunning schemes and high-tech heists.",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "My Musical Love Story",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-musical-love-story/230x131.png",
    iframe: "https://games.cutedressup.net/my-musical-love-story/",
    Walkthrough: "https://www.youtube.com/embed/pdiHTYE8lXA",
    dis:"Dive into ‘My Musical Love Story,’ an interactive romance game where melodies meet emotions. Navigate your character’s journey through love, heartbreak, and the rhythm of music. Make choices, unlock chapters, and let the music of passion guide you. Immerse yourself in a symphony of emotions as you create your own love story. Will it be a harmonious melody or a poignant tune?",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Lovie Chic’s St Patricks Day Costumes",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lovie-chics-st-patricks-day-costumes/230x131.png",
    iframe: "https://games.cutedressup.net/lovie-chics-st-patricks-day-costumes/",
    Walkthrough: "https://www.youtube.com/embed/DpdeySxpyt4",
    dis:"Join the festive fun with Lovie Chic’s St Patricks Day Costumes! Explore a collection of vibrant green ensembles, lucky accessories, and Irish-inspired styles. Elevate your St. Patrick’s Day look with chic outfits that capture the spirit of the celebration. Join Lovie Chic in setting trends for this lively holiday. From parades to parties, embrace the charm of St. Patrick’s Day with fashion that brings luck and style to your wardrobe. Let the green magic unfold in every outfit with Lovie Chic’s expert inspiration!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Celebrity Spring Manicure Design",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-spring-manicure-design/230x131.png",
    iframe: "https://games.cutedressup.net/celebrity-spring-manicure-design/",
    Walkthrough: "https://www.youtube.com/embed/DpdeySxpyt4",
    dis:"Step into the glamour of ‘Celebrity Spring Manicure Design’! Explore a world of trendy nail art, vibrant colors, and chic designs. Join celebrities in setting the trend for spring nails. Elevate your style with creative manicures, from floral elegance to modern motifs. Immerse yourself in the art of nail fashion and transform your fingertips into a canvas of spring-inspired beauty. Express your unique style, celebrate the season, and make your nails a fashion statement with Celebrity Spring Manicure Design!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Ellie And Friends Floral Outfits",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ellie-and-friends-floral-outfits/230x131.png",
    iframe: "https://games.cutedressup.net/ellie-and-friends-floral-outfits/",
    Walkthrough: "https://www.youtube.com/embed/T5xfaOEuitc",
    dis:"Dress in the beauty of nature with ‘Ellie and Friends Floral Outfits’! Explore a blossoming collection of stylish ensembles and vibrant accessories. Elevate your look with the freshness of floral fashion in this exciting adventure. Join Ellie and Friends as they set trends with petals and patterns, making every outfit a garden of style. From casual strolls to garden parties, embrace the allure of floral elegance in your wardrobe. Let the fashion bloom!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Lovie Chics In Fantasy World",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lovie-chics-in-fantasy-world/230x131.png",
    iframe: "https://games.cutedressup.net/lovie-chics-in-fantasy-world/",
    Walkthrough: "https://www.youtube.com/embed/c_WAphzz5FE",
    dis:"Embark on a magical journey with ‘Lovie Chics In Fantasy World’! Explore enchanted realms, mythical styles, and whimsical accessories. Join the chic adventure as Lovie Chics set trends in a world of fantasy. Elevate your style with ethereal fashion, from fairy-inspired ensembles to magical accessories. Let the fantasy world inspire your wardrobe and make every day an enchanting fashion moment. Immerse yourself in the magic of fashion!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Kendel 7 Days 7 Styles",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/kendel-7-days-7-styles/230x131.png",
    iframe: "https://games.cutedressup.net/kendel-7-days-7-styles/",
    Walkthrough: "https://www.youtube.com/embed/bIivHyNJbVg",
    dis:"Dive into a week-long fashion adventure with ‘Kendel 7 Days 7 Styles’! Explore a daily wardrobe transformation, from casual chic to elegant evenings. Join Kendel in setting trends and elevating your style each day. Immerse yourself in the excitement of diverse fashion, unlock new looks, and make every day a stylish statement. From Monday to Sunday, embrace the thrill of reinventing your style with Kendel’s expert inspiration. Elevate your wardrobe and step into a week of endless fashion possibilities!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Celebrity Lunar New Year",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-lunar-new-year/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-lunar-new-year/",
    Walkthrough: "https://www.youtube.com/embed/9wubQ4LgpFI",
    dis:"Step into the star-studded glamour of ‘Celebrity Lunar New Year’! Explore festive ensembles, elegant accessories, and the magic of the lunar celebration. Join celebrities as they set the trend for the perfect Lunar New Year look. Elevate your style and embrace the cultural richness with the ultimate celebrity-inspired fashion. From traditional elegance to modern chic, let the stars guide you in creating a memorable and stylish Lunar New Year wardrobe. Celebrate in glamour with Celebrity Lunar New Year!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Lovie Chic’s Trendy Off Shoulder Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lovie-chics-trendy-off-shoulder-look/250x142.png",
    iframe: "https://games.cutedressup.net/lovie-chics-trendy-off-shoulder-look/",
    Walkthrough: "https://www.youtube.com/embed/tqcQnr8B31Q",
    dis:"Dive into the chic world of Lovie Chic’s Trendy Off Shoulder Look! Explore fashionable ensembles, stylish accessories, and the allure of the off-shoulder trend. Join Lovie Chic on a fashion journey where every look exudes sophistication. Elevate your style with off-shoulder elegance and let Lovie Chic be your guide to the ultimate trendy wardrobe. From casual outings to glamorous evenings, discover the charm of the off-shoulder look with Lovie Chic’s expert inspiration!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Lovie Chic’s #CandyLand Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lovie-chics-candyland-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/lovie-chics-candyland-fashion/",
    Walkthrough: "https://www.youtube.com/embed/jDgvI6RqPcg",
    dis:"Dive into a world of love and discovery with Lovie Chic’s #CandyLand Fashion - the ultimate romantic hidden object adventure! Unleash your inner cupid as you embark on a delightful quest to find the 10 hidden hearts in each of the 15 enchanting levels. ",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Valentine Hidden Heart",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/valentine-hidden-heart/250x142.png",
    iframe: "https://games.cutedressup.net/bestgamespot/valentine-hidden-heart/",
    Walkthrough: "https://www.youtube.com/embed/qWZ5BW50u8I",
    dis:"Dive into a world of love and discovery with Valentine Hidden Heart - the ultimate romantic hidden object adventure! Unleash your inner cupid as you embark on a delightful quest to find the 10 hidden hearts in each of the 15 enchanting levels. ",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Celebrity Biker Vogue",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-biker-vogue/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-biker-vogue/",
    Walkthrough: "https://www.youtube.com/embed/qWZ5BW50u8I",
    dis:"Rev up your style with ‘Celebrity Biker Vogue’! Explore the fusion of edgy and chic as celebrities redefine biker fashion. From leather jackets to sleek helmets, witness the clash of high fashion on the open road. Join the ride, elevate your style, and embrace the rebellious glamour of celebrity biker vogue. Let the stars guide you on a fashionable journey where the road becomes a runway, and every outfit is a statement. Gear up for a stylish adventure in the world of Celebrity Biker Vogue!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Ellie And Friends Get Ready For First Date",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ellie-and-friends-get-ready-for-first-date/230x131.png",
    iframe: "https://games.cutedressup.net/ellie-and-friends-get-ready-for-first-date/",
    Walkthrough: "https://www.youtube.com/embed/qWZ5BW50u8I",
    dis:"Join Ellie And Friends Get Ready For First Date! Explore chic ensembles, trendy accessories, and glamorous styles to make a lasting impression. Dive into the excitement of the first date as these fashion-forward friends set the trend for the perfect look. Elevate your style game, embrace the thrill of romance, and let Ellie and Friends guide you through a fashionable journey to a memorable first date. Make every moment stylish and unforgettable!",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Snow White All Around The Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/snow-white-all-around-the-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/snow-white-all-around-the-fashion/",
    Walkthrough: "https://www.youtube.com/embed/yYQZy68u5KU",
    dis:"Dive into the juicy and colorful world of Fruit Merge Reloaded, a captivating merging game that combines the addictive gameplay of 2048 with the sweetness of your favorite fruits! Your task is to merge identical fruits to create new and exotic varieties, aiming to reach the ultimate fruit fusion.",
  },
  {
    id: 202401012,
    brand: "playcutegames",
    title: "Fruit Merge Reloaded",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/fruit-merge-reloaded/250x142.png",
    iframe: "https://games.cutedressup.net/bestgamespot/fruit-merge-reloaded/",
    Walkthrough: "https://www.youtube.com/embed/",
    dis:"Dive into the juicy and colorful world of Fruit Merge Reloaded, a captivating merging game that combines the addictive gameplay of 2048 with the sweetness of your favorite fruits! Your task is to merge identical fruits to create new and exotic varieties, aiming to reach the ultimate fruit fusion.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity In Venice Carnival",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-in-venice-carnival/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-in-venice-carnival/",
    Walkthrough: "https://www.youtube.com/embed/p78SmfCqh5k",
    dis:"Step into the Celebrity In Venice Carnival! Explore the glamorous clash of styles as celebrities navigate the snowy season. From cozy layers to high-end fashion, witness the stars setting trends in a winter wonderland. Join the clash, elevate your winter style, and immerse yourself in the magic of celebrity fashion. Let the snowy backdrop be the canvas for a clash of elegance and glamour. Bundle up and embrace the chic side of winter with your favorite celebrities!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Winter Wonderland Clash",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-winter-wonderland-clash/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-winter-wonderland-clash/",
    Walkthrough: "https://www.youtube.com/embed/LCfiBeabXXg",
    dis:"Step into the Celebrity Winter Wonderland Clash! Explore the glamorous clash of styles as celebrities navigate the snowy season. From cozy layers to high-end fashion, witness the stars setting trends in a winter wonderland. Join the clash, elevate your winter style, and immerse yourself in the magic of celebrity fashion. Let the snowy backdrop be the canvas for a clash of elegance and glamour. Bundle up and embrace the chic side of winter with your favorite celebrities!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Mermaid All Around The Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/mermaid-all-around-the-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/mermaid-all-around-the-fashion/",
    Walkthrough: "https://www.youtube.com/embed/jflKIGiVgQc",
    dis:"Dive into the diverse world of ‘Mermaid All Around The Fashion! Explore a myriad of styles, from casual chic to elegant evening looks. Join the Mermaid Princess fashion journey, discover the latest trends, and elevate your style game. With an array of outfits and accessories, the possibilities are endless. Unleash your creativity and make a statement in every ensemble. From day to night, Mermaid Princess has you covered in the ever-evolving world of fashion!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Bffs Fabulous Winter Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-fabulous-winter-look/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-fabulous-winter-look/",
    Walkthrough: "https://www.youtube.com/embed/LCfiBeabXXg",
    dis:"Dive into winter glamour with BFFs Fabulous Winter Look! Explore chic ensembles, cozy layers, and trendy accessories. Join the BFFs as they set the trend for the perfect winter look. Elevate your style and embrace the magic of the season with the ultimate BFFs winter fashion inspiration. From festive gatherings to snowy adventures, let the BFFs guide you to a fabulously fashionable winter!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs Retro Time Travel Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-retro-time-travel-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-retro-time-travel-fashion/",
    Walkthrough: "https://www.youtube.com/embed/i93tAKNBYDg",
    dis:"Take a stylish journey through time with BFFs Retro Time Travel Fashion! Explore vintage ensembles, iconic trends, and timeless accessories. Join the BFFs as they navigate the fashion eras, setting trends in every decade. Elevate your style with a retro twist and let the BFFs be your guides in the ultimate time-traveling fashion adventure. Rediscover the charm of bygone styles and create a timeless wardrobe with the BFFs!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Ellie And Friends Ski Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ellie-and-friends-ski-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/ellie-and-friends-ski-fashion/",
    Walkthrough: "https://www.youtube.com/embed/hGS9EVvz0k4",
    dis:"Embark on a chic alpine journey with Ellie and Friends Ski Fashion! Explore trendy winter ensembles, cozy layers, and stylish accessories. Join the fashionable slope adventure as Ellie and friends set the trend for the perfect ski look. Elevate your winter style and hit the slopes in glamour. Unleash the magic of ski fashion with Ellie and friends as your stylish guides. Glide through the season in fashion-forward attire!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs Winter Ice Skating Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-winter-ice-skating-look/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-winter-ice-skating-look/",
    Walkthrough: "https://youtu.be/ExpM8AzpD4U",
    dis:"Dive into the frosty enchantment of BFFs Winter Ice Skating Look! Explore chic winter ensembles, cozy layers, and stylish accessories for the perfect ice-skating adventure. Join the BFFs as they glide through the season in fashion-forward attire. Elevate your winter style and embrace the magic of frosty fashion with the ultimate Ice Skating Look inspiration. Let the chilly breeze be your runway!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Ellie NYE Sequin Party",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ellie-nye-sequin-party/250x142.png",
    iframe: "https://games.cutedressup.net/ellie-nye-sequin-party/",
    Walkthrough: "https://youtu.be/_vq69fIIoyA",
    dis:"Step into the glamour of Ellie NYE Sequin Party! Explore dazzling sequined ensembles, sparkling accessories, and celebrate the countdown in style. Join the glitzy festivities as Ellie sets the trend for the perfect New Year’s Eve look. Elevate your party style and shine into the new year with Ellie’s dazzling inspiration. Unleash the magic of sequins and make your NYE celebration a shimmering sensation!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Warm And Chic Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-warm-and-chic-look/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-warm-and-chic-look/",
    Walkthrough: "https://youtu.be/tefsFgEh1Vo",
    dis:"Experience Celebrity Warm and Chic Look! Immerse yourself in the cozy elegance of star-inspired winter fashion. From luxurious coats to trendy accessories, discover the secrets behind celebrities’ stylish warmth. Join the fashion journey and elevate your cold-weather wardrobe with the perfect blend of comfort and glamour. Embrace winter in celebrity style!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrities Night Out Outfits",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrities-night-out-outfits/250x142.png",
    iframe: "https://games.cutedressup.net/celebrities-night-out-outfits/",
    Walkthrough: "https://youtu.be/ET7ZZotyQzc",
    dis:"Explore the glitz and glamour of Celebrities Night Out Outfits! Step into the world of high fashion as your favorite stars showcase their iconic styles. From red carpet elegance to chic street looks, discover the secrets behind their stunning night-out ensembles. Join the fashion parade and get inspired to elevate your own evening wardrobe. Uncover the allure of celebrity fashion and make every night out a memorable style statement!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Fashionista Christmas Eve Party",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/fashionista-christmas-eve-party/250x142.png",
    iframe: "https://games.cutedressup.net/fashionista-christmas-eve-party/",
    Walkthrough: "https://youtu.be/AN2M6L95z2c",
    dis:"Indulge in the Fashionista Christmas Eve Party extravaganza! Discover glamorous holiday ensembles, festive accessories, and the perfect blend of chic for a stylish celebration. Join the fashion-forward festivities and elevate your Christmas Eve style to new heights. Unwrap the magic of the season with Fashionista, where every outfit is a statement and every moment is a fashion triumph. Let the glamour of Christmas Eve unfold.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrities Get Ready For Christmas",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrities-get-ready-for-christmas/250x142.png",
    iframe: "https://games.cutedressup.net/celebrities-get-ready-for-christmas/",
    Walkthrough: "https://youtu.be/DmeOmLJOjnE",
    dis:"Step into the world of ‘Celebrities Get Ready for Christmas’! Join your favorite stars as they prepare for the festive season. Explore dazzling holiday outfits, glamorous decorations, and witness the magic of Christmas through the eyes of celebrities. Get ready for a star-studded holiday celebration! Play and have fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Lovie Chic’s Stylish Maxi Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lovie-chics-stylish-maxi-look/250x142.png",
    iframe: "https://games.cutedressup.net/lovie-chics-stylish-maxi-look/",
    Walkthrough: "https://youtu.be/Z8RTINQ9qqY",
    dis:"Dive into Lovie Chic’s Stylish Maxi Look! Elevate your fashion game with chic maxi dresses, trendy accessories, and expert styling tips. Embrace comfort and glamour in every step. Help the chic to pick up a perfect maxi outfit. Join the style revolution and discover your perfect maxi ensemble with Lovie Chic!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Lovie Chic’s Black Vs Pink Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lovie-chics-black-vs-pink-style/250x142.png",
    iframe: "https://games.cutedressup.net/lovie-chics-black-vs-pink-style/",
    Walkthrough: "https://youtu.be/H0mD-N4keBw",
    dis:"Lovie Chic’s Black Vs Pink Style Want to play? Play this game online for free on playcutegames in fullscreen. Lots of fun to play when bored at home or at school. Play and have fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Fashionista Rainy Day Edition",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/fashionista-rainy-day-edition/250x142.png",
    iframe: "https://games.cutedressup.net/fashionista-rainy-day-edition/",
    Walkthrough: "https://youtu.be/lVs_lIc1bTk",
    dis:"Step into the world of Fashionista Rainy Day Edition! Embrace the charm of rainy days with our curated collection of chic ensembles, stylish rainwear, and trendy accessories. Join the fashion journey as we redefine rainy day fashion, proving that even in drizzles, your style can shine. Elevate your wardrobe with weather-appropriate yet fabulous choices. Stay dry, stay fabulous, and make a splash with your rainy day looks!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Lisa Fashion Club #Style Challenge",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lisa-fashion-club-style-challenge/250x142.png",
    iframe: "https://games.cutedressup.net/lisa-fashion-club-style-challenge/",
    Walkthrough: "https://youtu.be/fqRGY__OIg8",
    dis:"Dive into Lisa Fashion Club #Style Challenge! Discover how your favorite stars rock winter fashion with cozy layers, chic outerwear, and trendy accessories. Get inspired to elevate your cold-weather wardrobe and stay fashion-forward all season. Join us in exploring the glamour of celebrity winter fashion! Elevate your seasonal wardrobe with inspiration from the glamorous world of celebrities.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Cold Weather Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-cold-weather-style/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-cold-weather-style/",
    Walkthrough: "https://youtu.be/rJDSz1xzp8M",
    dis:"Dive into Celebrity Cold Weather Style! Discover how your favorite stars rock winter fashion with cozy layers, chic outerwear, and trendy accessories. Get inspired to elevate your cold-weather wardrobe and stay fashion-forward all season. Join us in exploring the glamour of celebrity winter fashion! Elevate your seasonal wardrobe with inspiration from the glamorous world of celebrities.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Lovie Chic’s Fall Dress Up",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lovie-chics-fall-dress-up/250x142.png",
    iframe: "https://games.cutedressup.net/lovie-chics-fall-dress-up/",
    Walkthrough: "https://youtu.be/9FnPeY7-Fx4",
    dis:"Indulge in the ultimate Lovie Chic’s Fall Dress Up spree! BFF girls are excited to go out for shopping on Black Friday. Explore exclusive deals, trendy fashion finds, and must-have accessories. Elevate your style and make the most of this exciting shopping extravaganza. Join us for a day of style and savings!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Lovie Chics Black Friday Shopping",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lovie-chics-black-friday-shopping/250x142.png",
    iframe: "https://games.cutedressup.net/lovie-chics-black-friday-shopping/",
    Walkthrough: "https://youtu.be/0q-wcsoLb-k",
    dis:"Indulge in the ultimate Lovie Chics Black Friday Shopping spree! BFF girls are excited to go out for shopping on Black Friday. Explore exclusive deals, trendy fashion finds, and must-have accessories. Elevate your style and make the most of this exciting shopping extravaganza. Join us for a day of style and savings!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFF’s Day Of Dead Celebration",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-day-of-dead-celebration/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-day-of-dead-celebration/",
    Walkthrough: "https://youtu.be/9Lhvd0bFlVY",
    dis:"BFF’s Day Of Dead Celebration Want to play? Play this game online for free on playcutegames in fullscreen. Lots of fun to play when bored at home or at school. Play and have fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Thanksgiving Squad Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/thanksgiving-squad-style/250x142.png",
    iframe: "https://games.cutedressup.net/thanksgiving-squad-style/",
    Walkthrough: "https://youtu.be/",
    dis:"Thanksgiving Squad Style Want to play? Play this game online for free on playcutegames in fullscreen. Lots of fun to play when bored at home or at school. Play and have fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Trip To International Balloon Fiesta",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/trip-to-international-balloon-fiesta/250x142.png",
    iframe: "https://games.cutedressup.net/trip-to-international-balloon-fiesta/",
    Walkthrough: "https://youtu.be/ZNxVR0uktk8",
    dis:"Welcome to the Trip to International Balloon Fiesta! Join the BFFs as they plan a trip to embrace the spirit of adventure. Get ready to experience vibrant festivities and magical hot air balloons in style. Elevate your travel wardrobe and create picture-perfect memories with your best friends! Play and have fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Lucy All Season Fashionista",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lucy-all-season-fashionista/250x142.png",
    iframe: "https://games.cutedressup.net/lucy-all-season-fashionista/",
    Walkthrough: "https://youtu.be/RycnDXDHsnA",
    dis:"Lucy All Season Fashionista Want to play? Play this game online for free on playcutegames in fullscreen. Lots of fun to play when bored at home or at school. Play and have fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs Unique Halloween Costumes",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-unique-halloween-costumes/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-unique-halloween-costumes/",
    Walkthrough: "https://youtu.be/9hQ3K5AVjpk",
    dis:"Join the BFFs Unique Halloween Costumes adventure! These best friends are on a mission to find the most creative and distinctive Halloween outfits. Get ready for a one-of-a-kind Halloween experience as they plan, choose, and showcase their unique costumes. Unleash your creativity and celebrate Halloween like never before with the trendiest and most original looks!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Monster Girls Back To School",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/monster-girls-back-to-school/250x142.png",
    iframe: "https://games.cutedressup.net/monster-girls-back-to-school/",
    Walkthrough: "https://youtu.be/0PQeSr1bD6o",
    dis:"Welcome to Monster Girls Back To School. Join the Monster Girls as they prep for school! Assist them in selecting the ideal outfits for a stylish return. Dive into their supernatural world, full of fashion choices and exciting back-to-school adventures. Get ready to be their fashion guide and have fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Halloween Costumes",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-halloween-costumes/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-halloween-costumes/",
    Walkthrough: "https://youtu.be/BoS07BubpUA",
    dis:"Welcome to Celebrity Halloween Costume Adventure! Your favorite celebrities are planning the perfect Halloween outfits together. Get ready for a star-studded Halloween experience as they choose and showcase their ultimate costumes. Unleash your inner celebrity with the hottest Halloween trends!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Cute Melon My Dream Profession",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/cute-melon-my-dream-profession/250x142.png",
    iframe: "https://games.cutedressup.net/cute-melon-my-dream-profession/",
    Walkthrough: "https://youtu.be/vNulEfnyKDg",
    dis:"Dive into the enchanting world of ‘Cute Melon My Dream Profession,’ where kids embark on a journey to uncover their dream careers. Dress up kids in exciting professions and have fun while sparking their ambition!” Join us in fostering the next generation’s dreams and aspirations through educational and delightful experiences!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Luma The Fashion Stylist",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/luma-the-fashion-stylist/250x142.png",
    iframe: "https://games.cutedressup.net/luma-the-fashion-stylist/",
    Walkthrough: "https://youtu.be/N2T1j5xU2EE",
    dis:"Welcome to Luma The Fashion Stylist Game. Introducing Luma, the fashion stylist extraordinaire. With a keen eye for trends, Luma effortlessly navigates styles like casual chic, minimalist, feminine, urban, tomboy, and hip-hop. Elevate your fashion skills and discover your unique style for Luma with your expert guidance. Unleash the fashionista in you!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Ice Princess All Around The Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ice-princess-all-around-the-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/ice-princess-all-around-the-fashion/",
    Walkthrough: "https://youtu.be/",
    dis:"Welcome to the Ice Princess All Around The Fashion. Enter the enchanting world of the Ice Princess, where fashion knows no bounds! Explore a realm of icy elegance and timeless style. From regal ball gowns to chic modern looks, discover a wardrobe fit for a princess. Join her on a journey through the world of fashion, where every outfit tells a story. Unleash your inner fashionista and embrace the magic of the Ice Princess’s style!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Angela Multiverse Fashionista",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/angela-multiverse-fashionista/250x142.png",
    iframe: "https://games.cutedressup.net/angela-multiverse-fashionista/",
    Walkthrough: "https://youtu.be/buGjMuGUKNQ",
    dis:"Step into Angela Multiverse Fashionista world, where style transcends dimensions! Explore her diverse wardrobe spanning galaxies, eras, and realms. From futuristic space chic to timeless historical elegance, unlock fashion inspiration that knows no bounds. Join Angela on a journey through the multiverse of couture and express your unique style across the cosmos. Your fashion adventure begins here!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Insta Celebrity Hashtag Goals",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/insta-celebrity-hashtag-goals/250x142.png",
    iframe: "https://games.cutedressup.net/insta-celebrity-hashtag-goals/",
    Walkthrough: "https://youtu.be/e6VGg-1yzNo",
    dis:"Unlock your inner star with Insta Celebrity Hashtag Goals! Celebrities plan to elevate their fashionista in social media. Join and help them to complete their goal at each level. Mix and match the outfit on each level. Take a picture and post it on social media to earn more points. Have fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Summer Firecamp Adventure",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/summer-firecamp-adventure/230x131.png",
    iframe: "https://games.cutedressup.net/summer-firecamp-adventure/",
    Walkthrough: "https://youtu.be/jr3PcLAgCvY",
    dis:"Welcome to Summer Firecamp Adventure. A little girl planned to have a summer fire camp near the lake. Help her prepare for the trip, to reach the destination, and also help her in fishing and preparing s’mores. Sounds fun right?? Join and make this summer more unforgettable for her. Have fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BTS Signature Fashion Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bts-signature-fashion-style/250x142.png",
    iframe: "https://games.cutedressup.net/bts-signature-fashion-style/",
    Walkthrough: "https://youtu.be/jr3PcLAgCvY",
    dis:"Dive into the world of BTS Signature Fashion Style. Explore the iconic looks of the global superstars and discover how to incorporate their trendsetting fashion into your own wardrobe. From stage outfits to everyday streetwear, get inspired and elevate your style with a touch of BTS’s unparalleled flair. Join us on a fashion journey that transcends borders and celebrates individuality with the influence of these K-pop icons.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Ellie And Friends Pre Fall Outfit",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ellie-and-friends-pre-fall-outfit/250x142.png",
    iframe: "https://games.cutedressup.net/ellie-and-friends-pre-fall-outfit/",
    Walkthrough: "https://youtu.be/k4DMuC3rw4o",
    dis:"Transition into fall with the Ellie and Friends Pre-Fall Outfit collection. Explore a fusion of style and comfort as they curate trendy ensembles featuring cozy layers, versatile accessories, and seasonal hues. Embrace the upcoming season with fashion-forward choices inspired by the experts themselves! Join and have fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "V And N Pizza Cooking Game",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/v-and-n-pizza-cooking-game/250x142.png",
    iframe: "https://games.cutedressup.net/v-and-n-pizza-cooking-game/",
    Walkthrough: "https://youtu.be/HvO3LEDT8RI",
    dis:"Experience the ultimate virtual pizza-making adventure with the V And N Pizza Cooking Game! Craft delicious pizzas from scratch, choose mouthwatering toppings, and master the art of baking. From classic favorites to innovative creations, unleash your inner chef and create culinary masterpieces. With immersive gameplay and endless combinations, satisfy your pizza cravings and become a virtual pizzaiolo extraordinaire. Get ready to cook, create, and enjoy the taste of success in this exciting cooking game!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Ellie All Around The Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ellie-all-around-the-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/ellie-all-around-the-fashion/",
    Walkthrough: "https://youtu.be/4cc9a6Ou9Aw",
    dis:"Immerse yourself in the world of Ellie All Around The Fashion! From casual chic to red-carpet glam, join Ellie’s style journey. Discover versatile outfits, trendy accessories, and expert fashion tips. Whether it’s a day out or a special event, find inspiration for every occasion. Unleash your inner fashionista and elevate your style with Ellie as your guide. Explore, experiment, and embrace a world of endless fashion possibilities.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Monster Girls Glam Goth Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/monster-girls-glam-goth-style/250x142.png",
    iframe: "https://games.cutedressup.net/monster-girls-glam-goth-style/",
    Walkthrough: "https://youtu.be/4cc9a6Ou9Aw",
    dis:"Discover the dark allure of Monster Girls Glam Goth Style! Embrace gothic charm, mystical fashion, and edgy elegance as enchanting characters flaunt their unique looks. Dive into a world of captivating outfits, hauntingly beautiful accessories, and mesmerizing aesthetics. Unleash your inner goth and explore a fashion realm like no other, where the mystical meets the glamorous. Join the bewitching squad and express your dark and stylish side with this new game.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Trendy Prom Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-trendy-prom-look/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-trendy-prom-look/",
    Walkthrough: "https://youtu.be/",
    dis:"Steal the spotlight at prom with our Celebrity Trendy Prom Look! Embrace A-list elegance with chic dresses, glamorous hairstyles, and stunning accessories. Get inspired by the red carpet fashion and create a show-stopping ensemble that will leave everyone in awe. Make your prom night a celebrity-worthy affair and feel like a star on your special evening!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs Holographic Futuristic Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-holographic-futuristic-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-holographic-futuristic-fashion/",
    Walkthrough: "https://youtu.be/Cng2bSteVWQ",
    dis:"Step into a dazzling world of BFFs Holographic Futuristic Fashion! Explore a realm of shimmering outfits, holographic accessories, and futuristic styles. Join these best friends on their fashion journey, blending technology and trend to create mesmerizing looks. Get inspired, mix and match, and embrace the cutting-edge allure of holographic fashion!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Monster Girls High School Squad",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/monster-girls-high-school-squad/250x142.png",
    iframe: "https://games.cutedressup.net/monster-girls-high-school-squad/",
    Walkthrough: "https://youtu.be/tAGWj5xle3o",
    dis:"Unleash your inner fashionista with the Monster Girls High School Squad dress-up game! Mix and match captivating outfits, accessorize with magical charms, and create spellbinding looks for supernatural students. Dive into a world of style, friendship, and enchantment as you explore the fantastic wardrobe options and dress up the alluring characters. Join the squad and let your creativity run wild in this thrilling fashion adventure!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Wednesday Addams Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-wednesday-addams-style/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-wednesday-addams-style/",
    Walkthrough: "https://youtu.be/Sbp6Xhy3qqs",
    dis:"Indulge in the iconic and bewitching Celebrity Wednesday Addams Style! Embrace the darkly chic aesthetics, explore mesmerizing outfits, and channel your inner gothic elegance. Discover how celebrities rock the macabre charm of Wednesday Addams with a modern twist. Unleash your inner darkness and redefine elegance with a touch of the mysterious.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Monster High Signature Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/monster-high-signature-style/250x142.png",
    iframe: "https://games.cutedressup.net/monster-high-signature-style/",
    Walkthrough: "https://youtu.be/n3y9Oi3uJ0s",
    dis:"Embrace the supernatural allure of Monster High Signature Style! Dive into a world where ghoulish fashion takes center stage. Discover unique outfits, hauntingly beautiful accessories, and the signature style of your favorite monster characters. Unleash your inner monster and join the stylish haunting fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity AfroPunk Street Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-afropunk-street-style/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-afropunk-street-style/",
    Walkthrough: "https://youtu.be/VBkmMcijSOA",
    dis:"Step into the world of Celebrity AfroPunk Street Style and discover a vibrant fusion of fashion, music, and self-expression. Explore captivating looks, bold outfits, and cutting-edge trends as celebrities showcase their unique personal style. Immerse yourself in this electrifying fashion movement and get inspired to make a statement of your own.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Ellie Bachelorette Party",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ellie-bachelorette-party/250x142.png",
    iframe: "https://games.cutedressup.net/ellie-bachelorette-party/",
    Walkthrough: "https://youtu.be/wmp_ZhL1dBE",
    dis:"Welcome to Ellie Bachelorette Party! It’s time to celebrate with her closest friends before the big day. Get ready for a night of laughter, dancing, and unforgettable memories. From fun games to fabulous surprises, this party is all about showering Ellie with love and creating an evening she’ll treasure forever. Join us and let’s make this celebration truly extraordinary!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity BarbieCore Aesthetic Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-barbiecore-aesthetic-look/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-barbiecore-aesthetic-look/",
    Walkthrough: "https://youtu.be/VBkmMcijSOA",
    dis:"Welcome to Celebrity BarbieCore Aesthetic Look. Step into the glamorous world of celebrity fashion with this game! Six famous stars are inspired by BarbieCore’s iconic style and are eager to try her trends. From dazzling red carpet gowns to chic streetwear, they’ll explore the diverse range of BarbieCore aesthetics. Experiment with stunning hairstyles, flawless makeup, and luxurious accessories. Become their personal stylist and guide them to embody the essence of BarbieCore’s fashion-forward allure. Unleash your creativity and make them shine like true style icons!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs High School First Date Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-high-school-first-date-look/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-high-school-first-date-look/",
    Walkthrough: "https://youtu.be/IzmLYMPI94E",
    dis:"Welcome to BFFs High School First Date Look. Get ready to style BFFs for their exciting high school first date! Mix and match trendy outfits, hairstyles, and accessories to create the perfect look that will make them feel confident and impress their date. Can you help them to find the ultimate outfit that captures their unique style and personality? Let the fashion fun begin!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Ellie Summer Spa And Beauty Salon",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ellie-summer-spa-and-beauty-salon/250x142.png",
    iframe: "https://games.cutedressup.net/ellie-summer-spa-and-beauty-salon/",
    Walkthrough: "https://youtu.be/",
    dis:"Ellie Summer Spa & Beauty Salon: Dive into the glamorous world of beauty and fashion as you run your own spa and salon empire! Treat clients to soothing massages, refreshing facials, and stunning makeovers. Create unique styles and become the ultimate beauty guru in this addictive and fun game.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs Fashion Sequin Addict",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-fashion-sequin-addict/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-fashion-sequin-addict/",
    Walkthrough: "https://youtu.be/mm0Jy-3PkzE",
    dis:"Welcome to BFFs Fashion Sequin Addict. BFFs want to try cute sparkling sequin outfits! Mix and match glamorous dresses, tops, bottoms, and accessories from their wardrobe, and create stunning looks for the runway. Show off your fashion sense and become the ultimate sequin addict! Join and help the girls.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs Black And Pink Fashionista",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-black-and-pink-fashionista/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-black-and-pink-fashionista/",
    Walkthrough: "https://youtu.be/ZFtXJuXCa5Y",
    dis:"In BFFs Black and Pink Fashionista, BFFs are planning a style extravaganza, embracing the power of black and pink. They aim to create head-turning outfits by combining sleek black pieces with vibrant pink accents. With their impeccable taste and creative flair, they’re set to redefine fashion boundaries and inspire others to embrace the boldness of this stunning color combination. Get ready for a fashion revolution that celebrates the perfect blend of edgy and feminine styles.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Panda Tropical Wedding Story",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/panda-tropical-wedding-story/230x131.png",
    iframe: "https://games.cutedressup.net/panda-tropical-wedding-story/",
    Walkthrough: "https://youtu.be/yTCfJXZFzm0",
    dis:"Step into the vibrant world of the Panda Tropical Wedding Story! Unleash your creativity as you style the adorable pandas in stunning tropical wedding outfits. Mix and match glamorous dresses, stylish accessories, and beautiful hairstyles to make the pandas look their best on their special day. Get ready for a fashion-filled adventure!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "My Perfect Pastel Looks",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-perfect-pastel-looks/250x142.png",
    iframe: "https://games.cutedressup.net/my-perfect-pastel-looks/",
    Walkthrough: "https://youtu.be/647kNKeDeyU",
    dis:"Welcome to My Perfect Pastel Looks. Bffs want to try sweet and vibrant candy-inspired outfits. Mix and match colorful clothes, accessories, and hairstyles to create the most fabulous and delicious fashion looks. Let your creativity shine in this sugary fashion adventure! Unleash your creativity and create the most fabulous looks in this sweet and stylish game. Get ready for a mouthwatering fashion experience!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs Candy Fashion Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-candy-fashion-look/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-candy-fashion-look/",
    Walkthrough: "https://youtu.be/tGlSDfIPbV8",
    dis:"Welcome to BFFs Candy Fashion Look. Bffs want to try sweet and vibrant candy-inspired outfits. Mix and match colorful clothes, accessories, and hairstyles to create the most fabulous and delicious fashion looks. Let your creativity shine in this sugary fashion adventure! Unleash your creativity and create the most fabulous looks in this sweet and stylish game. Get ready for a mouthwatering fashion experience!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs Biker Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-biker-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-biker-fashion/",
    Walkthrough: "https://youtu.be/YUxXRA6C6dg",
    dis:"Get ready to hit the road in style with BFFs Biker Fashion! Choose from a wide range of trendy outfits, leather jackets, boots, and accessories to create the perfect biker look. Show off your fashion skills and transform these best friends into the ultimate biker babes! Play and have fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Kendel All Around The Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-kendel-all-around-the-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-kendel-all-around-the-fashion/",
    Walkthrough: "https://youtu.be/kpF6FbJK6wQ",
    dis:"Welcome to Celebrity Kendel All Around The Fashion. Kendel All, the sensational celebrity, takes the fashion world by storm in this exciting game! Join her on a glamorous journey as she conquers the runway, designs stunning outfits, and transforms into a style icon. Explore luxurious locations, attend exclusive events, and compete against fashion elites to become the ultimate trendsetter. With endless customization options and a captivating storyline, Kendel All Around The Fashion is a must-play for fashion enthusiasts!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Sunflower Shine Looks",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-sunflower-shine-looks/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-sunflower-shine-looks/",
    Walkthrough: "https://youtu.be/rNT08ap5Zq8",
    dis:"Welcome to Celebrity Sunflower Shine Looks. These celebrities are more fond of sunflower pattern outfits. They already filled the latest collection in their wardrobe. Explore a variety of dresses, accessories, and more, in their wardrobe. Mix and match different pieces to create the perfect ensemble that captures the essence of these beautiful flowers.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Swifty All Around The Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-swifty-all-around-the-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-swifty-all-around-the-fashion/",
    Walkthrough: "https://youtu.be/2LkRE1h9Wh0",
    dis:"Welcome to Celebrity Swifty All Around The Fashion. Celebrity Swifty plans to try different fashion trends. She needs some help to choose the perfect costumes and outfits. Browse her wardrobe and choose the perfect outfits for each fashion trend. Play and have fun with this new Celebrity game for girls!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Classic Summer Stripes ",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-classic-summer-stripes/230x131.png",
    iframe: "https://games.cutedressup.net/celebrity-classic-summer-stripes/",
    Walkthrough: "https://youtu.be/CmPYK0yR4vA",
    dis:"Welcome to Celebrity Classic Summer Stripes. Let’s style your favorite celebrities in summer stripes fashion. Browse their wardrobe and choose from a selection of striped tops, bottoms, dresses, and accessories to create the perfect summer look for them. You can mix and match different pieces to create a one-of-a-kind look. So, let your imagination run wild and create the ultimate summer stripes look for your favorite celebrity!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs Summer Beach Vibes ",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-summer-beach-vibes/230x131.png",
    iframe: "https://games.cutedressup.net/bffs-summer-beach-vibes/",
    Walkthrough: "https://youtu.be/XyK06GpZ59I",
    dis:"BFFs Summer Beach Vibes is a fun and exciting game that lets you dress up four best friends for a day at the beach. You get to choose from a variety of trendy outfits and accessories to create the perfect beach look. They are excited to spend the day soaking up the sun and having fun at the beach. Join and help them pick out their outfits for the day. You can choose from a variety of beach outfits, sunglasses, and hats to create a stylish beach look for each friend.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "My Coachella Festival Outfits",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-coachella-festival-outfits/250x142.png",
    iframe: "https://games.cutedressup.net/my-coachella-festival-outfits/",
    Walkthrough: "https://youtu.be/RaGnPgnJ2h4",
    dis:"Welcome to My Coachella Festival Outfits. Ellie and her friends are more excited to attend the Coachella Festival this year. Browse their wardrobe to mix and match different clothing items, accessories, hairstyles, and makeup to create unique and trendy outfits for them. With a wide variety of options to choose from, you can experiment with different styles and fashion trends, including bohemian, grunge, retro, and more.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Boho Summer Style ",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-boho-summer-style/230x131.png",
    iframe: "https://games.cutedressup.net/celebrity-boho-summer-style/",
    Walkthrough: "https://youtu.be/StPWgVoc8uY",
    dis:"Celebrity Boho Summer Style is a summer fashion dress-up game. In this game, Celebrities plan to have a party on the beach with bohemian-inspired outfits. Browse their wardrobe to mix and match different clothing items, accessories, and hairstyles to create a unique look. Join to play with your favorite celebrities and have fun!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Bffs Cherry Blossom Festival Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-cherry-blossom-festival-look/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-cherry-blossom-festival-look/",
    Walkthrough: "https://youtu.be/t1z5b8FTFR0",
    dis:"The BFFs Cherry Blossom Festival Look dress-up game is a fun and interactive way to plan your perfect outfit for a springtime festival with your best friend. In this game, Bffs plan to get ready for the cherry blossom festival. You have to help them to choose clothing options, including pastel dresses, floral prints, and other spring-inspired pieces to create an ideal look.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Wild Animal Care And Salon",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/wild-animal-care-and-salon/230x131.png",
    iframe: "https://games.cutedressup.net/wild-animal-care-and-saloon/",
    Walkthrough: "https://youtu.be/PwlohL2Fxlo",
    dis:"Wild Animal Care And Salon” is an interactive simulation game where players take on the role of caretaker and stylist for a variety of wild animals. Players will be responsible for giving treatment, feeding, grooming, and playing with the animals to keep them healthy and happy. As they progress through the game, players will unlock new animals to care for, each with their own unique needs and personalities.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "My Trendy Oversized Outfits Street Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-trendy-oversized-outfits-street-style/250x142.png",
    iframe: "https://games.cutedressup.net/my-trendy-oversized-outfits-street-style/",
    Walkthrough: "https://youtu.be/lwjxtxhyIzE",
    dis:"Welcome to My Trendy Oversized Outfits Street Style. Oversized Outfits… so trendy these days! But it’s not easy building up a suitable outfit! This BFF will wear one today, and they need a bit of help to pick a perfect one.  Help them out! They have plenty of cool Oversized Outfits in their wardrobe which you can mix and match however you like, and check out the accessories too; those are amazing! ",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "My Dreamy Flora Fashion Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-dreamy-flora-fashion-look/250x142.png",
    iframe: "https://games.cutedressup.net/my-dreamy-flora-fashion-look/",
    Walkthrough: "https://youtu.be/rnJMcyk0HdQ",
    dis:"Welcome to My Dreamy Flora Fashion Look. Girls! You know that spring is on its way when you see the trees starting to bud and bloom, and the bulbs you planted last fall start to sprout out of the ground. Join with Ellie and their friends to celebrate the most beautiful and colorful season.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Spring Haute Couture Season 1",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/spring-haute-couture-season-1/250x142.png",
    iframe: "https://games.cutedressup.net/spring-haute-couture-season-1/",
    Walkthrough: "https://youtu.be/3yBQ8THHzNU",
    dis:"Welcome to Spring Haute Couture Season 1. These celebrities get more excited to be a part of Spring Haute Couture. Join and browse their wardrobe to pick the perfect outfits and costumes. Don’t forget to pick a unique hairstyle. Are you ready to try the perfect one for the girls? Play and have fun!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Easter Fashionista",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-easter-fashionista/230x131.png",
    iframe: "https://games.cutedressup.net/celebrity-easter-fashionista/",
    Walkthrough: "https://youtu.be/R5tpiMQFxUA",
    dis:"Welcome to Celebrity Easter Fashionista. Do you celebrate Easter? These celebrities are going to celebrate Easter together doing all kinds of fun and creative activities. They are going to get ready for the Easter celebration! Browse their wardrobe and pick the perfect outfit for them. Come and join your favorite celebrities.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Ellie Easter Adventure",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ellie-easter-adventure/230x131.png",
    iframe: "https://games.cutedressup.net/ellie-easter-adventure/",
    Walkthrough: "https://youtu.be/AgFc8O4o424",
    dis:"Welcome to Ellie Easter Adventure. Ellie wants to celebrate in style! But she needs your help to get everything prepared! But first things first, you have to help her to find the easter egg and paint it with cute colors. Next, give treatment to the bunny to heal his wound. Finally, help Ellie to pick cute makeup and outfits to celebrate Easter.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Aqua Fish Dental Care",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/aqua-fish-dental-care/250x142.png",
    iframe: "https://games.cutedressup.net/aqua-fish-dental-care/",
    Walkthrough: "https://youtu.be/4Exz1LUzB2I",
    dis:"Welcome to Aqua Fish Dental Care. Aquatic organisms need a dentist! Come and join as a dental expert and treat all the species with care. It’s time to explore the amazing underwater world and give dental treatment to all the cute species! Each level has different species and you have to use all the equipment to complete the process.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Little Lily St.Patrick’s Day Photo Shoot",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/little-lily-st-patricks-day-photo-shoot/250x142.png",
    iframe: "https://games.cutedressup.net/little-lily-st-patricks-day-photo-shoot/",
    Walkthrough: "https://youtu.be/9aDdPpImRSI",
    dis:"Welcome to Little Lily St.Patrick’s Day Photo Shoot. St. Patrick’s Day is just around the corner, it’s time to celebrate the rich culture and heritage of Ireland! This festive day is a time to wear green! Help Little Lily to get ready for this wonderful day! Browse her wardrobe and pick a cute outfit with matching accessories.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Bff St Patrick’s day Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bff-st-patricks-day-look/250x142.png",
    iframe: "https://games.cutedressup.net/bff-st-patricks-day-look/",
    Walkthrough: "https://youtu.be/QLNPD3IJ5XI",
    dis:"Welcome to Bff St Patrick’s day Look. Have you ever heard about St. Patrick’s Day? Prepare your girlfriends for the holiday party in the game BFF St. Patricks Day game. The main color of the holiday is green, so the outfits are mainly made in this color. First, select a unique outfit, hat, hairstyle, and stylish accessories.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Casual Winter Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-casual-winter-look/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-casual-winter-look/",
    Walkthrough: "https://youtu.be/5Xi6N4cL-y4",
    dis:"Welcome to Celebrity Casual Winter Look. Winter is usually the coldest season of the year, but this doesn’t mean this celebrity can’t be stylish during these less sunny days of the year. Browse the wardrobe and pick suitable outfits and costumes to welcome this winter! Play and have fun!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Super Girls Magical Fairy land",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/super-girls-magical-fairy-land/250x142.png",
    iframe: "https://games.cutedressup.net/super-girls-magical-fairy-land/",
    Walkthrough: "https://youtu.be/aiKd8LbN--0",
    dis:"Welcome to Super Girls Magical Fairy land. These cute Bffs are looking for some fairytale-inspired outfit ideas for the upcoming fairyland ball of the season! To create a perfect look, you will first need to browse through the wardrobe to check out the dresses and costumes we put together! There are many different looks you can go for, from a delicate fairy princess, a powerful warrior princess, a flower or season fairy to an oriental empress look. You will find amazing hairdo ideas and accessories with cute fairy wings.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Super Girls Ripped Jeans Outfits",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/super-girls-ripped-jeans-outfits/250x142.png",
    iframe: "https://games.cutedressup.net/super-girls-ripped-jeans-outfitss/",
    Walkthrough: "https://youtu.be/5DAF1zHjls8",
    dis:"Welcome to Super Girls Ripped Jeans Outfits. Hello Girls! Are you feeling crafty today? Let’s try ripped-pattern jeans with different cool colors. Help the girls to browse and pick suitable jeans from their wardrobe. Try some matching accessories and different hairstyles for a perfect look.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Ari All Around The Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-ari-all-around-the-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-ari-all-around-the-fashions/",
    Walkthrough: "https://youtu.be/veoylS8faT0",
    dis:"Welcome to Celebrity Ari All Around The Fashion. Celebrity Ari plans to try different fashion trends. She needs some help to choose the perfect costumes and outfits. Browse her wardrobe and choose the perfect outfits for each fashion trend. Play and have fun with this new game!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Bff Stylish Off Shoulder Outfits",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bff-stylish-off-shoulder-outfits/250x142.png",
    iframe: "https://games.cutedressup.net/bff-stylish-off-shoulder-outfitss/",
    Walkthrough: "https://youtu.be/2lrTcYfdTAA",
    dis:"Welcome to Bff Stylish Off Shoulder Outfits. The off-shoulder top never gets out of style! This clothing piece is so cute and feminine, perfect for a day! These BFFs can’t wait to fill their closets with as many dresses as possible. This can mean only one thing, they need to go shopping and you could help them find the perfect one.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Bffs Venice Carnival Celebrations",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-venice-carnival-celebration/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-venice-carnival-celebrations/",
    Walkthrough: "https://youtu.be/2lrTcYfdTAA",
    dis:"Welcome to BFFs Venice Carnival Celebrations. Bffs are planning a trip to Italy to join the Venice carnival. Sounds fun right? Help the girls with the quick preparation. Browse their wardrobe and pick suitable costumes and hairstyles. Don’t forget to choose the mask for the party. Join these girls and have fun!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Valentine Nail Salon",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/valentine-nail-salon/250x142.png",
    iframe: "https://games.cutedressup.net/valentine-nail-salon/",
    Walkthrough: "https://youtu.be/ibv37Ce1T98",
    dis:"Welcome to Valentine Nail Salon. You own this chic nail salon where many girls come to have their manicures done. As today is Valentine’s day, you have to create a sweet romantic manicure for your client who wants to look wonderful on such an important day. So, prove what a good nail artist you are by making her hands look glamorous. Choose the length and the shape of the nails you want and then begin painting them with style. Choose the nail polish color you want to use and color the nails as fancy as you can. You can give her a very trendy french manicure or a classic one, you can use a single color or multiple ones. There are also some cool nail accessories and fancy rings you can choose from to make her hands look perfect.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Avatar The Way Of Love",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/avatar-the-way-of-love/250x142.png",
    iframe: "https://games.cutedressup.net/avatar-the-way-of-love/",
    Walkthrough: "https://youtu.be/EMu97EhaAz0",
    dis:"Welcome to Avatar The Way Of Love. Can you guess what day it is? Okay, maybe we can give you a clue. Love is in the air tonight. Yeah, it’s Valentine’s Day alright. These Avatar couples love to spend time together this valentine’s in the city. They plan to wear new trendy clothes.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Angela valentine Story Deep Water",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/angela-valentine-story-deep-water/230x131.png",
    iframe: "https://games.cutedressup.net/angela-valentine-story-deep-water/",
    Walkthrough: "https://youtu.be/hgg4vM9cKu4",
    dis:"Welcome to Angela valentine Story Deep Water. Angela feels lonely after her BF hates her so much in recent days. She asked help to her friend. Her friend gave her the gain his love back using a love potion. But she needs to go on an adventure hunt to get the love potion. Help her to join back to her BF.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Selen All Around The Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-selena-all-around-the-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-selen-all-around-the-fashion/",
    Walkthrough: "https://youtu.be/",
    dis:"Welcome to Celebrity Selen All Around The Fashion. Celebrity Selen plans to try different fashion trends. She needs some help to choose the perfect costumes and outfits. Browse her wardrobe and choose the perfect outfits for each fashion trend. Play and have fun with this new game!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "All Seasons Nail Salon",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/all-seasons-nail-salon/250x142.png",
    iframe: "https://games.cutedressup.net/all-seasons-nail-salon/",
    Walkthrough: "https://youtu.be/13dLbahfazA",
    dis:"Welcome to All Seasons Nail Salon. It is manicure madness over here and it’s your time to become the greatest Nail Salon of the year! All you need to do is choose the shape, paint, polish, and also help to pick beautiful accessories and tattoos. Play and have fun!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Sundance Film Festival",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-sundance-film-festival/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-sundance-film-festival/",
    Walkthrough: "https://youtu.be/",
    dis:"Welcome to the Celebrity Sundance Film Festival. Celebrity invited to the Sundance event. They are excited to participate in this event. Browse her wardrobe and pick cute outfits and costumes for the event. Help them and have fun!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity’s Chinese New Year Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-riri-all-around-the-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-riri-all-around-the-fashion",
    Walkthrough: "https://youtu.be/",
    dis:"Welcome to Celebrity RiRi All Around The Fashion. Celebrity RiRi plans to try different fashion trends. She needs some help to choose the perfect costumes and outfits. Browse her wardrobe and choose the perfect outfits for each fashion trend. Play and have fun with this new game!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity’s Chinese New Year Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-chinese-new-year-look/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-chinese-new-year-look",
    Walkthrough: "https://youtu.be/OljV-UGqhfI",
    dis:"Welcome to Celebrity’s Chinese New Year Look. Celebrities are getting ready to celebrate the Chinese New Year in style. Care to help them prepare for it? In this online for girls, you can help your favorite Celebrity, choose new outfits and statement makeup looks for the upcoming festive days. What do you think they should wear on this occasion?",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs Dark Academia Winter Outfits",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-dark-academia-winter-outfits/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-dark-academia-winter-outfits",
    Walkthrough: "https://youtu.be/qt8HwRZsnuM",
    dis:"Welcome to BFFs Dark Academia Winter Outfits. BFFs are getting ready for school. There’s a new cool fashion style they want to try on; dark academia. Mix and match the clothes to create unique outfits and complete the look with amazing makeup. Help the girls to pick cute outfits.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Mr and Mrs Santa Christmas Adventure",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/mr-and-mrs-santa-christmas-adventure/250x142.png",
    iframe: "https://games.cutedressup.net/mr-and-mrs-santa-christmas-adventure",
    Walkthrough: "https://youtu.be/LQi43kI3iKc",
    dis:"Welcome to Mr. and Mrs. Santa Christmas Adventure.  Christmas is around the corner. Mr. and Mrs. Santa preparing for the celebration. Unfortunately, Mr. Santa met an accident. Santa and his pet got severe injuries and also his sleigh was damaged totally. Help Santa and his pet for a quick recovery so that he can tour around the world to share his Christmas gift with the children.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "My Winter Cozy Outfits",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-winter-cozy-outfits/250x142.png",
    iframe: "https://games.cutedressup.net/my-winter-cozy-outfits",
    Walkthrough: "https://youtu.be/CbOTH5duCPU",
    dis:"Welcome to My Winter Cozy Outfits. Winter is not a season, It’s a celebration. Enjoy this winter with these cute besties. BFF wants to try something special this winter. Join and help the girls to pick cute outfits and accessories. Don’t forget to choose a matching hairstyle! Play and have fun!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "My New Year’s Sparkling Outfits",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-new-years-sparkling-outfits/250x142.png",
    iframe: "https://games.cutedressup.net/my-new-years-sparkling-outfits",
    Walkthrough: "https://youtu.be/pex6YWXMeic",
    dis:"Welcome to My New Year’s Sparkling Outfits. BFF girls plan for a new year surprise party. They are so excited to try new fashion trends for this new year. Help the girls to pick a cute sparkling outfit and pick cute matching accessories for each girl. Don’t forget to choose a unique hairstyle.",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Angela Christmas Dress up Game",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/angela-christmas-dress-up-game/250x142.png",
    iframe: "https://games.cutedressup.net/angela-christmas-dress-up-game",
    Walkthrough: "https://youtu.be/D5r0O4e3YLg",
    dis:"Welcome to Angela Christmas Dress Up Game. Christmas is around the corner. Angela is more excited than us to enjoy this Christmas with her friends. She has some crazy ideas to make this Christmas more fun! Join and help her to bake and decorate cakes, a Christmas tree, Cookies, and her house.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "New Years Eve Cruise Party",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/new-years-eve-cruise-party/250x142.png",
    iframe: "https://games.cutedressup.net/new-years-eve-cruise-party",
    Walkthrough: "https://youtu.be/6nHqN3Bud7w",
    dis:"Welcome to New Years Eve Cruise Party. Ellie and her friends are excited for Christmas celebrations. They want to try cute Christmas outfits with crazy makeovers. Browse their wardrobe for cute outfits and pick some matching accessories. Join these girls and enjoy this Christmas a most memorable one. Have fun!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "My Perfect Christmas Costumes",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-perfect-christmas-costumes/250x142.png",
    iframe: "https://games.cutedressup.net/my-perfect-christmas-costumes",
    Walkthrough: "https://youtu.be/9n0PamZ81IA",
    dis:"Welcome to My Perfect Christmas Costumes. Ellie and her friends are excited for Christmas celebrations. They want to try cute Christmas outfits with crazy makeovers. Browse their wardrobe for cute outfits and pick some matching accessories. Join these girls and enjoy this Christmas a most memorable one. Have fun!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Super Girls My Rainy Day Outfits",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/super-girls-my-rainy-day-outfits/250x142.png",
    iframe: "https://games.cutedressup.net/super-girls-my-rainy-day-outfits",
    Walkthrough: "https://youtu.be/hb8jHgGvrJ8",
    dis:"Welcome to Super Girls My Rainy Day Outfits. Who said that you can’t look perfect on a rainy day? A bit of rain shouldn’t stop us from looking fabulous! And don’t even worry about the hair, some curls under a hat look absolutely perfect! How would your perfect rainy day outfit look like? Try creating it while helping these princesses dress up in warmer clothes and rain boots. Accessorize their look with a hat, scarf, and a cute umbrella.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "My Trendy Ball Gown",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-trendy-ball-gown/250x142.png",
    iframe: "https://games.cutedressup.net/my-trendy-ball-gown",
    Walkthrough: "https://youtu.be/c6cLz_X4Sg8",
    dis:"Welcome to My Trendy Ball Gown. Rainbow Girls are going to be styled by you for the prom, but before that help them to choose the best outfit, also accessorize it using earrings, necklaces, and purses, and you can pick the hairstyle you think will suit the girl the best, simple as that. Enjoy!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs Black Friday Collection",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-black-friday-collection/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-black-friday-collection",
    Walkthrough: "https://youtu.be/XKnZGw9Ux-M",
    dis:"Welcome to BFFs Black Friday Collection. Bffs already filled the closet with a new Black Friday outfit. Help them to pick the perfect costume. Don’t forget to pick a fabulous hairstyle. They are all excited like us for this day. Join and help the girls with your skill. Play and have fun",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Ellie Thanksgiving Day",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ellie-thanksgiving-day/250x142.png",
    iframe: "https://games.cutedressup.net/ellie-thanksgiving-day",
    Walkthrough: "https://youtu.be/axGgjVHwHOY",
    dis:"Welcome to Ellie Thanksgiving Day. It’s Thanksgiving Day, and like every year, young Ellie is in charge of the Thanksgiving dinner. Her friends will start arriving soon, and there are still a few things that need her attention. Will you help her with the last preparations? Join and help beautiful Ellie to surprise her guests with a perfect dinner! ",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "My Unique Prom Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-unique-prom-look/250x142.png",
    iframe: "https://games.cutedressup.net/my-unique-prom-look",
    Walkthrough: "https://youtu.be/mX-gSB16lJs",
    dis:"Welcome to PFW Fall Ready To Wear Season 1. Celebrity girls are ready for their next fashion adventure. Yes! It’s Paris Fashion Week. Help them to be more unique in their look for this wonderful event. Browse their wardrobe and select the fabulous outfits for this event. Don’t forget to choose the matching accessories. Play and have fun!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "PFW Fall Ready To Wear Season 1",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/pfw-fall-ready-to-wear-season-1/250x142.png",
    iframe: "https://games.cutedressup.net/pfw-fall-ready-to-wear-season-1",
    Walkthrough: "https://youtu.be/",
    dis:"Welcome to PFW Fall Ready To Wear Season 1. Celebrity girls are ready for their next fashion adventure. Yes! It’s Paris Fashion Week. Help them to be more unique in their look for this wonderful event. Browse their wardrobe and select the fabulous outfits for this event. Don’t forget to choose the matching accessories. Play and have fun!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Paris Fashion Week Fall Couture",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/paris-fashion-week-fall-couture/250x142.png",
    iframe: "https://games.cutedressup.net/paris-fashion-week-fall-couture",
    Walkthrough: "https://youtu.be/jll4JIO39AY",
    dis:"Welcome to Paris Fashion Week Fall Couture. Join with Bffs in their awesome journey in Paris Fashion Week and prepare yourself to be amazed by the designers, models, and trends gracing the runways. Help the girls to choose the perfect fashion costumes. Have fun!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "NYFW Street Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/nyfw-street-style/250x142.png",
    iframe: "https://games.cutedressup.net/nyfw-street-style",
    Walkthrough: "https://youtu.be/b_T2Mk57fhw",
    dis:"Welcome to NYFW Street Style. Rainbow girls are excited to try some really amazing street-style fashion outfits and accessories! So, play it and get inspired for your own wardrobe! Check out all those fabulous items and choose your favorites to dress the beautiful model up with style! She should look amazing in the end, so make sure you pick up the perfect outfit for her!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Little Lily Halloween Prep",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/little-lily-halloween-prep/250x142.png",
    iframe: "https://games.cutedressup.net/little-lily-halloween-prep",
    Walkthrough: "https://youtu.be/",
    dis:"Welcome to Little Lily Halloween Prep. It’s time to celebrate Halloween with Little Lily! Enjoy a memorable Halloween night with Lily and play fun-packed Halloween games and activities. Help the lily to complete her makeover, then help her with Halloween face painting. Browse her wardrobe and pick cute outfits and costumes. Finally, help her with cake decoration. A lot more to enjoy and explore this Halloween season with Little Lily. Happy Halloween!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "My Perfect Halloween Costume",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-perfect-halloween-costume/250x142.png",
    iframe: "https://games.cutedressup.net/my-perfect-halloween-costume",
    Walkthrough: "https://youtu.be/era5WKrPocI",
    dis:"Welcome to My Perfect Halloween Costume. Bff Girls decided to celebrate this spooky holiday, just like when they were kids! This means that these princesses will go trick-or-treating dressed up in great costumes! This means that you can help them find the best costumes out there, which is not easy! As you will see, there are so many choices. Open the wardrobe and see it yourself.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Half And Half Celebrity Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/half-and-half-celebrity-style/250x142.png",
    iframe: "https://games.cutedressup.net/half-and-half-celebrity-style",
    Walkthrough: "https://youtu.be/kmW84YTKi9c",
    dis:"Welcome to Half And Half Celebrity Style. Celebrity wants to try brand new half & half-style. It’s now popular all over social media. Get them ready for a night out and mix and match the clothes to create unique half & half looks. Use your fashion skill and help the celebrity for this new fashion.",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs Welcome Fall Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-welcome-fall-look/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-welcome-fall-look",
    Walkthrough: "https://youtu.be/I7vVzKwdABQ",
    dis:"Welcome to BFFs Welcome Fall Look. Autumn is a beautiful season. Bffs is going to throw a party in the forest. They invited other friends to the party. Open the closet and dress up for the Bffs and her friends. An accessory is a must for a great look. Enjoy the game called BFFs Welcome Fall Look!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Stylish Fashion Challenge",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/stylish-fashion-challenge/250x142.png",
    iframe: "https://games.cutedressup.net/stylish-fashion-challenge",
    Walkthrough: "https://youtu.be/",
    dis:"Welcome to the Stylish Fashion Challenge.  A stylish Fashionista plans to show her fashion skill to her opponent. Join and play as a fashion designer for her. Help her to pick a nice costume for each event and compare her costumes with other players. Browse her wardrobe and pick outfits and costumes which is suitable for the events. Play and have fun!",
  }, 
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Super Girls Fall Fashion trends",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/super-girls-fall-fashion-trends/250x142.png",
    iframe: "https://games.cutedressup.net/super-girls-fall-fashion-trends",
    Walkthrough: "https://youtu.be/WkiQ7kEdKc4",
    dis:"Welcome to Super Girls Fall Fashion trends. If you want to stay trendy this autumn play this new game called Super Girls Fall Fashion trends to dress up the super girls. These cute girls are real fashion addicts and they have just renewed their wardrobe. The girls are ready for autumn so hurry up and explore their wardrobe to see what kind of fashionable clothing pieces they hide there.",
  }, 
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Cat Girl Fashion Challenge",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/cat-girl-fashion-challenge/230x131.png",
    iframe: "https://games.cutedressup.net/cat-girl-fashion-challenge/",
    Walkthrough: "https://youtu.be/WkiQ7kEdKc4",
    dis:"Welcome to Cat Girl Fashion Challenge. Cat Girl is more conscious of her fashion. She plans to compete with all other fashionistas. Join and play as a fashion designer for cat girl. Help her to pick a nice costume for each event and compare her costumes with other players. Browse her wardrobe and pick outfits and costumes which is suitable for the events. Play and have fun!",
  }, 
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Celebrity Valentino Pink Collections",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-valentino-pink-collections/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-valentino-pink-collections",
    Walkthrough: "https://youtu.be/gX3DRC9m1qY",
    dis:"Welcome to Celebrity Valentino Pink Collections. Celebrity girls are more famous for their fashion trends. Now they planned to add a new collection to this series. Yes! It’s the Valentino Pink collection. They already filled the collection in their wardrobe. Browse and pick a suitable costume for each girl. Join and help the girls in their fashion preparation. Have fun!",
  }, 
  {
    id: 202203001,
    brand: "cutedressup",
    title: "PFW-The Big Shoulder Couture",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/pfw-the-big-shoulder-couture/250x142.png",
    iframe: "https://games.cutedressup.net/pfw-the-big-shoulder-couture",
    Walkthrough: "https://youtu.be/bs3dCSji258",
    dis:"Welcome to PFW-The Big Shoulder Couture. Celebrity girls are getting ready for another action. Yes! it’s Paris Fashion Week! They are excited to try big Shoulder Couture outfits. Browse their wardrobe and pick suitable outfits and accessories. Don’t forget to give unique hairstyles. Join them as fashion expert and help the girls to show their stunning fashion looks!",
  }, 
  {
    id: 202203001,
    brand: "cutedressup",
    title: "BFFs E Girl Vs Soft Girl",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-e-girl-vs-soft-girl/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-e-girl-vs-soft-girl",
    Walkthrough: "https://youtu.be/RyQDTtiZmSc",
    dis:"Welcome to BFFs E Girl Vs Soft Girl. Ellie and her friends love to try a new fashions. Everyone is talking about the Soft Girl and the E-girl style nowadays, which are the trending fashion styles preferred by teens worldwide. Both are trendy and have opposite aesthetics. The Soft Girl style embraces the girly girl look, sweet and cute, wearing lots of pinks. Ellie and her friends will explore both styles and you must help them out by creating their Soft Girl versus E-girl look!",
  }, 
 
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Bffs Fall Fashion Trends",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-fall-fashion-trends/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-fall-fashion-trends",
    Walkthrough: "https://youtu.be/3ETVdmS5o64",
    dis:"Welcome to Bffs Fall Fashion Trends. Fall is quite an exciting season when it comes to clothing and fashion, primarily because the harsher weather allows for more layering and combinations of clothes, which you can’t really do in the summer because it is too hot. Your favorite LOL girls want to rock looks inspired by the fall season, so you are here to give them this makeover they really need and have fun!",
  }, 
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Bffs Kidcore Outfits",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-kidcore-outfits/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-kidcore-outfits",
    Walkthrough: "https://youtu.be/YVviaWqMxJs",
    dis:"Welcome to Bffs Kidcore Outfits. Kidcore is an aesthetic that centers around bright colors, icons from the 90s, and kiddy themes. These young girls are very excited to try this fashion. Join as a fashion expert and browse the wardrobe for cute outfits. Pick a suitable one for each girl and give a unique hairstyle to them.",
  }, 
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Celebrity Couple Red Carpet Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-couple-red-carpet-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-couple-red-carpet-fashion",
    Walkthrough: "https://youtu.be/Nd2NI3wmxPI",
    dis:"Welcome to Celebrity Couple Red Carpet Fashion. A Celebrity couple was invited to a Hollywood award function. They are excited to join this event. At this event, all celebrities are welcomed on a traditional red carpet, so they planned to wear the best outfits and show themself as perfect couples. Join and play this new game! Have fun!",
  }, 
  {
    id: 202203001,
    brand: "cutedressup",
    title: "FNF Girlfriend Multiverse Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/fnf-girlfriend-multiverse-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/fnf-girlfriend-multiverse-fashion",
    Walkthrough: "https://youtu.be/egQcNjiRH8c",
    dis:"Welcome to FNF Girlfriend Multiverse Fashion. Friday Night Funkin Girl seems bored of trying music. She has a plan for something different other than music. Yes, she wants to try multiverse fashion! Sounds fun! right? Join and pick a different fashion outfit. At each level, her wardrobe is filled with different costumes. Help them to choose the best one!",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Friday Night Funkin First Date",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/friday-night-funkin-first-date/250x142.png",
    iframe: "https://games.cutedressup.net/friday-night-funkin-first-date/",
    Walkthrough: "https://youtu.be/NcY7JGu75PA",
    dis:"Welcome to Friday Night Funkin First Date. FNF girl and his boyfriend plan for a date. They want to be perfect in their looks. Pick up suitable night party outfits for them. Their wardrobe has already been filled with a new collection. Don’t forget to pick unique hairstyles and different costumes. Join and help them to make this date a more memorable one in their life.",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Super Girls Ready To Adventure",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/super-girls-ready-to-adventure/250x142.png",
    iframe: "https://games.cutedressup.net/super-girls-ready-to-adventure/",
    Walkthrough: "https://youtu.be/oFl6ruDP9QE",
    dis:"Welcome to Super Girls Ready To Adventure. Winx Girls loves magical and adventurous fashion. They planned to participate in superheroes cosplay events. Help them to pick some interesting Outfits. Browse their wardrobe for cute outfits and pick a suitable outfit for each one. Don’t forget try unique hairstyles and accessories. Play and have fun!",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "My Colorful Denim Days",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-colorful-denim-days/250x142.png",
    iframe: "https://games.cutedressup.net/my-colorful-denim-days/",
    Walkthrough: "https://youtu.be/",
    dis:"Welcome to My Colorful Denim Days. Hey Girls! Are you ready for the coolest outfits? The style for today is #denim! Barbie and his friends are curious to know which style suits them best. Mix and match the clothes and create awesome outfits for the girls. Browse and pick suitable costumes for them. Play and Have fun!",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Celebrity Dark Gothic Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-dark-gothic-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-dark-gothic-fashion/",
    Walkthrough: "https://youtu.be/yQMgCyg1fhQ",
    dis:"Welcome to Celebrity Dark Gothic Fashion. Celebrity girls plan something unique in fashion. They heard about Dark gothic fashion and were excited to try it. But they have some confusion to choose the best outfit. Browse the wardrobe and pick suitable costumes and outfits for girls. Join with girls and so your creative skill. ",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "My Sweet Lolita Dress",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-sweet-lolita-dress/250x142.png",
    iframe: "https://games.cutedressup.net/my-sweet-lolita-dress/",
    Walkthrough: "https://youtu.be/uWbgeiIUmFQ",
    dis:" Welcome to My Sweet Lolita Dress. LOL Surprise girls plan to try their sweet lolita fashion. Lolita fashion is a cute stylish way to dress up in puffy skirts, lacy blouses, and accessories, perfect to create your own colorful trendy fashion. Mix classical, sweet, and gothic lolita styles for a unique spin on the Japanese trend. Browse and find cute outfits for our girls. Join as a fashion expert and show your skill.",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Ellie And Ben Insta Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ellie-and-ben-insta-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/ellie-and-ben-insta-fashion/",
    Walkthrough: "https://youtu.be/74ZZ-u_QNxE",
    dis:"Welcome to Ellie And Ben Insta Fashion. Help Ellie and her boyfriend Ben to choose an outstanding outfit to show their fashion skill on Instagram. Browse their wardrobe and pick costumes based on their moods. You can make their looks better with the help of other accessories. Join and play with your favorite couples. Have fun!",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Celebrity Fashion Battle",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-fashion-battle/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-fashion-battle/",
    Walkthrough: "https://youtu.be/7nrf-_0vVvo",
    dis:"Welcome to Celebrity Fashion Battle. Celebrities always follow the latest trends in the fashion world. Meet the new fashion collection Spring-Summer 2022! The trend is bright flashy colors and a crazy combination of shades that will not leave anyone indifferent. Every celebrity wants to be inimitable. Which girl is ready to concede in this fashionable battle? Or will they shine until the last accessory? Don’t give your opponents a chance. Time for bold decisions and new experiences. Try on all these dresses, suits, skirts, pants, tops, shorts, and shoes! Show your creative nature and prove to everyone that you are a cool stylist.",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "My Perfect Weekend Outfits",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/my-perfect-weekend-outfits/250x142.png",
    iframe: "https://games.cutedressup.net/my-perfect-weekend-outfits/",
    Walkthrough: "https://youtu.be/5mjB5xH4HqM",
    dis:"Welcome to My Perfect Weekend Outfits. Are you ready for a crazy weekend with these Rainbow Girls? Do you know what they have planned? Play this game and help these girls get ready for a weekend full of adventures, but most importantly, help them get ready for it. They need to look absolutely fabulous so you need to help them find the perfect outfit and accessories, as well as the hairstyle!",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "K-Pop Stars Inspired Look",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/k-pop-stars-inspired-look/250x142.png",
    iframe: "https://games.cutedressup.net/k-pop-stars-inspired-look/",
    Walkthrough: "https://youtu.be/vVVXtVptilk",
    dis:"Welcome to K-Pop Stars Inspired Look. These girls love Korean pop music. They absolutely adore the world of k-pop, and they’re going to a nightclub where a DJ will be playing music by their favorite groups all night long! Help them choose awesome outfits and fast! You can also lend them a hand while they do their makeup in this beauty game.",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "BFFs Summer Aesthetic",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-summer-aesthetic/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-summer-aesthetic/",
    Walkthrough: "https://youtu.be/ekZmVhGP75M",
    dis:"Welcome to the BFFs Summer Aesthetic. Summer is here, and these 6 BFFs are already enjoying it in style with amazing trips around the world! This year, each of them picked a unique destination for the summer holiday, but they keep themselves updated by sending each other lots of pictures. Join them in, and get ready to discover the most beautiful colors of summer.",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Celebrity E-Girl Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-e-girl-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-e-girl-fashion/",
    Walkthrough: "https://youtu.be/ekZmVhGP75M",
    dis:"Welcome to the Celebrity E-Girl Fashion. These Celebrities were definitely among the very first online fashionistas to fall into this highly popularized trend, so get ready to be amazed by their edgy fashion style and awesome makeup. Today our e-girls have decided to upgrade their looks with something new and for that, they are going to need your expert advice. Join and help the girls!",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Ocean Kids Back To school",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/ocean-kids-back-to-school/250x142.png",
    iframe: "https://games.cutedressup.net/ocean-kidz-back-to-school/",
    Walkthrough: "https://youtu.be/cATCCaxiEHw",
    dis:"Welcome to Choose My summer Style game. Summer is just seconds away. These girls can’t wait for sun tan lines, longer days, and good times with friends during vacation. It’s time to freshen up their wardrobe for vacation. They’re excited to finally get out and enjoy the sun. Help them to choose their style for this summer.",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Choose My summer Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/choose-my-summer-style/250x142.png",
    iframe: "https://games.cutedressup.net/choose-my-summer-style/",
    Walkthrough: "https://youtu.be/04EQx-8mkEQ",
    dis:"Welcome to Choose My summer Style game. Summer is just seconds away. These girls can’t wait for sun tan lines, longer days, and good times with friends during vacation. It’s time to freshen up their wardrobe for vacation. They’re excited to finally get out and enjoy the sun. Help them to choose their style for this summer.",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Celebrity First Date Adventure",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-first-date-adventure/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-first-date-adventure/",
    Walkthrough: "https://youtu.be/l6TYgm8ev8Y",
    dis:"Welcome to Celebrity First Date Adventure. Our favorite Celebrity couple planned for an adventure date. Both are excited and want to be more attractive. They need some expert advice. Browse their wardrobe and pick a cute outfit for them. Help the couple and make their date the most memorable one!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFF Art Hoe Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bff-art-hoe-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/bff-art-hoe-fashion/",
    Walkthrough: "https://youtu.be/4e1FBScw-AQ",
    dis:"Welcome to BFF Art Hoe Fashion. Ellie and her friends are weary of trying the same fashion. Today they planned to try something new. Yes! It’s Art Hoe fashion!. You join as a fashion expert and give a company to these girls in choosing their perfect outfit. Browse their wardrobe and pick a suitable one. Don’t forget to help them with their makeover. Play and have fun!",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "BFFs Grunge Minimalist Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-grunge-minimalist-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-grunge-minimalist-fashion/",
    Walkthrough: "https://youtu.be/mwqvKFzf9GE",
    dis:"Welcome to BFFs Grunge Minimalist Fashion. The grunge look is a style based on the grunge music scene and these BFFs absolutely love it! The girls are always ready for a new fashion challenge and today they are exploring the grunge style! Are you ready to join in and help them find the perfect outfit?",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Celebrity Core Fashion Battle",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-core-fashion-battle/250x142.png",
    iframe: "https://games.cutedressup.net/celebrity-core-fashion-battle/",
    Walkthrough: "https://youtu.be/WpSXmkgQhhw",
    dis:"Welcome to Celebrity Core Fashion Battle. These celebrities want to try a core fashion. Each one of them wants to try a different core style. Help them to select a unique style for each one of them by choosing a fashion card. Then browse the wardrobe and pick cute outfits which shoe their fashion style.",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Influencers Aesthetic Fashion Challenge",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/influencers-aesthetic-fashion-challenge/250x142.png",
    iframe: "https://games.cutedressup.net/influencers-aesthetic-fashion-challenge/",
    Walkthrough: "https://youtu.be/_9iS91W-mtA",
    dis:" Welcome to the Influencers Aesthetic Fashion Challenge. Omg, the BFFs are going to participate in a new Influencer challenge. Complete the Look is the latest trend and you will have to pick cute makeup and a fabulous outfit for them. Pick a unique costume for all the girls. Play and have fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs Pinafore Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-pinafore-fashion/250x142.png",
    iframe: "https://games.cutedressup.net/bffs-pinafore-fashion/",
    Walkthrough: "https://youtu.be/1RuyAuKAfWc",
    dis:"Welcome to the BFFs Pinafore Fashion. Bffs planned to try new fashion with their old collection in their wardrobe. Yes! its Pinafore. Help them to put together a cute pinafore dress by first choosing a shape for the dress. Then decide if the dress should be in a single color or in one of the pre-made prints. Then you have to choose if the fabric of the dress should have a texture and add-ons like a zipper or buttons. After you’ve designed the dress, it’s time to dress up and style the model! ",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Influencers Girly Vs Tomboy",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/influencers-girly-vs-tomboy/250x142.png",
    iframe: "https://games.cutedressup.net/influencers-girly-vs-tomboy/",
    Walkthrough: "https://youtu.be/J7kEGLn0yr0",
    dis:" Welcome to the Influencers Girly Vs Tomboy. What should these celebrities choose today? A cute, girly-girl outfit or maybe a tomboy one? It’s going to be your task to help them out decide on that! Join them in getting this amazing dress-up game started, run your fingers through their amazing wardrobe, and help them to decide on the style that best suits their mood today. ",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "Angela Design With Me Winter Sweater",
    thumb:"https://cdncloud.cutedressup.in/playcutegames/thumb/cutedressup/angela-design-with-me-winter-sweater-130.png",
    iframe: "https://games.cutedressup.net/angela-design-with-me-winter-sweater",
    Walkthrough: " ",
    dis:"Welcome to Angela Design With Me Winter Sweater. At the beginning of the winter, Angela bought and renewed their wardrobe with cute sweaters. Now she tried everything and plan to design her own. Join and help Angela to design the better one. First, start choosing the shape of the sweater and then decorate this with beautiful color and pattern. Play and have fun!",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Perfect Tokyo Street Style",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/perfect-tokyo-street-style/300x300.jpg",
    iframe: "https://games.cutedressup.net/perfect-tokyo-street-style/",
    Walkthrough: "https://youtu.be/dq7qLktSQho",
    dis:" Welcome to the Perfect Tokyo Street Style. Princess Elsa, Anna, Moana, Ariel, Snow White, and Jasmine are the best friends. They planned to throw a surprise weekend fashion party. Everyone agreed to try Tokyo street style Fashion. join and browse the princesses wardrobe for the best collection of outfits and costumes. Play and have fun!",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "BFFs City Chic Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-city-chic-fashion/300x300.jpg",
    iframe: "https://games.cutedressup.net/bffs-city-chic-fashion/",
    Walkthrough: "https://youtu.be/dq7qLktSQho",
    dis:" Welcome to the BFFs City Chic Fashion. Rainbow Girls Sunny, Skyler, Ruby, and Violet have an idea to try Plus-sized clothing. Yes! Its city chic fashion. Browse the wardrobe and find a cute set of outfits for the girls. Join and play these new dress-up games for girls. Have fun!",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "BFFs Kimono Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/bffs-kimono-fashion/300x300.jpg",
    iframe: "https://games.cutedressup.net/bffs-kimono-fashion/",
    Walkthrough: "https://youtu.be/6ARcIoGSLr0",
    dis:" Welcome to BFFs Kimono Fashion. Princesses Anna, Elsa, Moana, Ariel, Snow White, and Jasmine are planning to try Japanese traditional fashion. Yes, it’s Kimino fashion. Girls are so excited to try it out to show their stunning look. Help the girls by browsing their wardrobe and picking suitable costumes for",
  },
  {
    id: 202203001,
    brand: "playcutegames",
    title: "LOL Surprise Preppy Fashion",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/lol-surprise-preppy-fashion/300x300.jpg",
    iframe: "https://games.cutedressup.net/lol-surprise-preppy-fashion/",
    Walkthrough: "https://youtu.be/wYA17jv2A6s",
    dis:"Welcome to LOL Surprise Preppy Fashion. LOL Suprise doll plans to try a new stylish fashion. Yes! It’s preppy fashion. Browse and choose the best set of outfits for them. Show your fashion skill and give them a stunning look. Enjoy this new collection of games and have fun!",
  },
  {
    id: 202203001,
    brand: "cutedressup",
    title: "Celebrity Love Candy Outfits",
    thumb:"https://cdn.cutedressup.in/games/cutedressup_new/celebrity-love-candy-outfits/300x300.jpg",
    iframe: "https://games.cutedressup.net/celebrity-love-candy-outfits/",
    Walkthrough: "https://youtu.be/2Dlm8VzbXLE",
    dis:" Welcome to Celebrity Love Candy Outfits. Celebrity girls Ariana Grande, Rihanna, Selena Gomez, Taylor Swift, and Kendell Jenner are best friends. They usually admire new trends. Now they plan to try candy fashion. Browse the wardrobe for each girl and pick a cute outfit for each one. Make sure everything is unique and different from other ones. Help the girls and have fun!",
  },
  // {
  //   id: 202203001,
  //   brand: "playcutegames",
  //   title: "Princess Ready For Christmas",
  //   thumb:"https://cutedressup.com/wp-content/uploads/2020/05/princess-ready-for-christmas-512x512-1.jpg",
  //   iframe: "https://games.cutedressup.net/princess_ready_for_christmas/",
  //   Walkthrough: "https://youtu.be/_kx3ml7aMZI",
  //
  //   dis:"With the Christmas Eve round the corner, the excitement always are at peak in the palace. The celebrations are round the corner with everyone gearing up towards it . Being a princess is even more fun. Let’s help the princess wear a cool party outfit for the Christmas Eve.",
  // },
];
